import React ,{useRef ,useEffect ,useState}from 'react';
import SecurityService from '../security/security.service';
import moment from 'moment'

import DynamicInputList from '../software-dynamic-version-2/list-input-v-2';
import DialogInput from '../software-dynamic-version-2/popup-dialog-input-v-2';


import BuyerAdd  from './buyer-add'
import BuyerService from './buyer.service';
import AuditTable from '../audit-table/audit-table';
import './buyer.scss'
import securityService from '../security/security.service';



const   BuyerInput = (props) => {
    // let handleCheckboxChange = (e,props)=>{
    //   console.log(e)
    //   BuyerService.delete(props.UserID).then(async (res)=>{
    //     document.getElementById(`checkbox_${props.UserID}`).checked =false
    //     await  showDialog('ALERT' ,<span class="error-success">User Actived</span>)
    //       // await getListService()
    //       })
    // }
  
    let columns =[
      { field: "buyerNTNCNIC", headerText:'NTN/CNIC', dataType:'Int', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "buyerBusinessName", headerText:'Business Name', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "buyerProvinceName", headerText:'Province', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "buyerAddress", headerText:'Address', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
    ];

        const listActionComplete = async (grid , args ,getListService ,selectedRow  ,setDataSourceState ,addUserLog,editUserLog)=>{
          console.log(args )
          console.log(getListService )
          console.log(selectedRow )
    
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }
        if(args.requestType == 'save'){
          let data = {
            buyerNTNCNIC:(args.data.buyerNTNCNIC || '').toUpperCase(),
            buyerBusinessName	:args.data.buyerBusinessName,
            stateProvinceCode	:args.data.stateProvinceCode || args.previousData.stateProvinceCode,
            buyerProvinceName:args.data.buyerProvinceName,
            buyerAddress:args.data.buyerAddress,
            buyerRegistrationType:args.data.buyerRegistrationType || null,
            sellerNTNCNIC:(args.data.sellerNTNCNIC || '').toUpperCase() || null
        }
    
          console.log(data)
        if(args.action == 'add'){
          BuyerService.insert(data).then(async (res)=>{
            await getListService()
            // inputName ,tableName,tableID,values
            // addUserLog('Seller'  ,'Seller',selectedRow,{
            //   UserName:args.data.UserName,
            //   UserFullName:args.data.UserFullName,
            // })
          })
        }
        if(args.action == 'edit'){
          BuyerService.update(data).then((res)=>{
            getListService()
            // tableName,tableIDValue,selectedRows,values
            // editUserLog('Seller',args.data.UserID,'UserID',{
            //   UserName:args.data.UserName,
            //   UserFullName:args.data.UserFullName,
            // })
          })
        }
        }
        
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = false
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = true
    let  allowDataBound = true
    let  allowGridSum = false
    let  isDialog = props.IsDialog == true ? true : false

       
        // Defines the  string
        // @default Seller${typeMode} 
        let ListSecurity='Buyer'
        let AddSecurity='Buyer'
        let EditSecurity='Buyer'
        let DeleteSecurity='Buyer'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      // let toolbarOptions ='All';
      let toolbarOptions =['Add','Edit', 'Delete' ,'Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'].filter(Boolean);
          

        //   const dialogRef = useRef(null);
        //   const showDialog = (header,title,actions =['OK']) => {
        //     return new Promise((resolve) => {
        //     // Destroy existing dialog if any
        //     if (dialogRef.current) {
        //       dialogRef.current.destroy();
        //     }
        //     const okButtons = actions.map((action) => ({
        //       buttonModel: {
        //         content: action,
        //         cssClass: 'e-flat',
        //         isPrimary: action === 'OK',
        //       },
        //       click: (e) => {
        //         hideDialog();
        //         resolve(action);
        //       },
        //     }));
        //     // Create a new dialog instance
        //     dialogRef.current = new DialogInput({
        //       content: ()=>(<>{title}</>),
        //       header:header,
        //       width:'340px',
        //       showButtons: true,
        //       buttons:okButtons
        //     });
        //     // Show the dialog programmatically
        //     dialogRef.current.show();

        //   });

        //   };
        // const hideDialog = () =>{
        //   if (dialogRef.current) {
        //   }
        //   dialogRef.current.hide();
        //   dialogRef.current.destroy();
        //   dialogRef.current = null; // Clean up reference after destruction
        // }

      const toolbarClicking =  async (grid , args , selectedRow , getListService)=>{
        console.log(grid , args)
        console.log(selectedRow)
      //   if(props.Active ==  false  ){
      //      if(args.name == "rowSelected" || args.name == "rowDeselected"){
      //     if(args.target?.type ==  'checkbox'){
      //   setTimeout( async () => {
          
      //     await getListService()
      //   }, 1500);
      // }
      // }
    
      // }
      //   if(args?.item?.properties?.id == 'IsActive'){
      //     if(selectedRow == undefined){
      //   await showDialog('WARNING' ,<span class="error-tooltip">Please select a row first!</span>)
      // }else{
      //   let dialogResult  = await showDialog('Confirmation' ,<span class="error-success">Are you sure you want to delete?</span> , ['OK','CANCEL'])
      //   console.log(dialogResult)
      // if(dialogResult == 'OK'){
      //   BuyerService.delete(selectedRow.UserID).then(async (res)=>{
      //   await  showDialog('ALERT' ,<span class="error-success">RECORD(S) DELETED SUCESSFULLY</span>)
      //     await getListService()
      //       AuditTable.auditDelete('Seller',selectedRow.UserID,{
      //         UserName:selectedRow.UserName,
      //         FullName:selectedRow.FullName,
      //       })
      //     })
      //   }
      //   }
      //   }
        
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'Seller' ,
                    TableID:'SellerID',
                   // Optional if Delete is Soft // TableSecurity:'SellerDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'Seller' ,TableID:'SellerID', Optional // TableSecurity:'SellerDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
    //  let filterColumns = [{ field: 'IsActive', value: props?.Active == false ? 'No' : 'Yes' }];
     let filterColumns = [];
      

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
      
        <DynamicInputList
        Id='Buyer'
        ListTitle='Buyer - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> BuyerService.getBuyerForList()
                        }]}
        DefaultSortedColumnName={'buyerNTNCNIC'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<BuyerAdd GridID={'Buyer'}/>
        
            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            AllowTemplate={allowTemplate}
            // ToolbarOption={toolbarOptions}
            AllowGrouping={allowGrouping}
            AllowExcelExport={allowExcelExport}
            AllowPdfExport={allowPdfExport} 
            ShowColumnChooser={showColumnChooser}
            AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={EditSecurity}
            DeleteSecurity={DeleteSecurity}
            DefaultSortedColumnSort={DefaultSortedColumnSort}
            FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            GroupColumns={groupColumns} 
            // ListDelete={listDelete}
             DeleteType={deleteType} 
            GridEditSettingMode={gridEditSettingMode}
            GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            // AllowGridSum={allowGridSum}
            IsDialog={isDialog}

            {...props}
            ></DynamicInputList>

            );
}



export default BuyerInput;
